module.exports = __webpack_public_path__ + "img/Tracicionales 5.2710792b.jpg";